import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const DraftStatus: LoadableType<{
	contentId: string;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-banner-itemsdraft-statusDraftStatus" */ '../src/banner-items/draft-status/DraftStatus.tsx'
			)
		).DraftStatus,
});
